'use client';

import { Spinner } from '@/components/ui/spinner';

type Props = {
  /** Copy del momento: crear la orden o confirmar el cobro. */
  label: string;
};

/** Spinner con copy contextual mientras se crea o se cierra la orden. */
export function CheckoutProcessingStep({ label }: Props) {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-6 py-20">
      <Spinner className="size-12" />
      <p className="text-xl font-medium">{label}</p>
    </div>
  );
}
